module.exports = __webpack_public_path__ + "img/metal-bg.b082261b.jpg";